// frontend/src/components/LanguageSwitcher.js
import React from 'react';
import { Select, MenuItem, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const languages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'kg', name: 'Кыргызча', flag: '🇰🇬' },
    { code: 'kz', name: 'Қазақша', flag: '🇰🇿' },
    { code: 'uz', name: "O'zbek", flag: '🇺🇿' },
    { code: 'tj', name: 'Тоҷикӣ', flag: '🇹🇯' },
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
    { code: 'ko', name: '한국어', flag: '🇰🇷' },
    { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
    { code: 'jv', name: 'Basa Jawa', flag: '🇮🇩' },
    { code: 'th', name: 'ไทย', flag: '🇹🇭' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'hy', name: 'Հայերեն', flag: '🇦🇲' },
    { code: 'ka', name: 'ქართული', flag: '🇬🇪' },
    { code: 'uk', name: 'Українська', flag: '🇺🇦' },
    { code: 'mn', name: 'Монгол', flag: '🇲🇳' },
    { code: 'tl', name: 'Tagalog', flag: '🇵🇭' },
    { code: 'ro', name: 'Română', flag: '🇷🇴' }
];

export const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    return (
        <Select
            value={i18n.language}
            onChange={(e) => i18n.changeLanguage(e.target.value)}
            size="small"
            sx={{ 
                ml: 2, 
                bgcolor: 'white', 
                minWidth: 150,
                '& .MuiSelect-select': {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                }
            }}
        >
            {languages.map((lang) => (
                <MenuItem 
                    key={lang.code} 
                    value={lang.code}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}
                >
                    <span style={{ fontSize: '1.2em' }}>{lang.flag}</span>
                    <span>{lang.name}</span>
                </MenuItem>
            ))}
        </Select>
    );
};

export default LanguageSwitcher;